<template>
	<div>
		<layout-login>
			<div :class="{'profile': $route.name === 'create-profile-applicants'}">
				<v-layout row class="header" v-show="$route.name === 'create-profile-applicants'">
					<h5>Perfil Profesional</h5>
				</v-layout>
				<v-layout row class="tw-items-center">
					<v-flex xs12 lg1 class="tw-flex tw-justify-start">
						<div class="wrapper-user-image">
							<div class="wrapper-user">
								<img 
									:src="applicant.urlImage" 
									alt="user"
									height="100%"
									width="100%">
							</div>
							<!-- <div class="wrapper-camera">
								<load-file
									:show-input="false"
									icon="camera_alt"
									color="white"
									class-btn="circle-btn"
									@input="getImage">
								</load-file>
							</div> -->
						</div>
					</v-flex>
					<v-flex xs12 lg11 class="info-applicant" :class="{'ml-4': $route.name !== 'create-profile-applicants'}">
						<h4>{{applicant.fullName}}</h4>
						<p>Completa y dale un vistazo a tu perfil profesional</p>
					</v-flex>
				</v-layout>
				<v-layout row wrap class="justify-space-between text-xs-center mt-5">
					<v-flex x12 lg3 class="box align-content-center" v-for="(box, index) in boxes" :key="index" :style="{ backgroundColor: box.color }">
						<div v-if="index === boxes.length - 1 && isEditing" style="display: flex; flex-direction: column; align-items: center;">
							<p>{{ box.nameInfo }}</p>
							<v-text-field
								v-model="box.job"
								class="input-text"
								style="width: 300px;"
								label="Nivel académico actual"
							></v-text-field>
							<app-tooltip-button
								icon="save"
								text="Guardar"
								color="gray"
								@click-icon="toggleEdit(false)"
							/>
						</div>
						<div v-else>
							<p>{{ box.nameInfo }}</p>
							<div style="display: flex; align-items: center; justify-content: center">
								<h3>{{ box.job }}</h3>
								<app-tooltip-button
								 	v-if="index === boxes.length - 1"
									icon="edit"
									text="Editar"
									color="gray"
									@click-icon="toggleEdit(true)"
								/>
							</div>
						</div>
					</v-flex>
				</v-layout>
				<v-divider style="margin-top: 30px; height: 1px; background: #B8B8B8;"></v-divider>
				<v-layout row wrap class="certificates justify-space-between">
					<v-flex xs12 class="title-qualifications">
						<h3>Mis titulaciones, cursos y certificados</h3>
						<p>¿Cuentas con titulaciones y/o certificados?, Súbelos aquí</p>
					</v-flex>
					<v-flex xs12 lg4>
						<h3 class="general-titles mb-3">Elige tu archivo:</h3>
						<drag-and-drop-file
							:disable="verifyUrl"
							:clean="files.length === 0"
							@upload-file="uploadFile"
						/>
					</v-flex>
					<v-flex xs12 lg7>
						<h3 class="general-titles mb-3">Datos generales</h3>
						<v-layout row wrap class="justify-space-between inputs">
							<v-flex xs12 lg5>
								<label
									class="name"
									:style="`color:${$appColors.info}`"
								>
									Nombre:
								</label>
								<v-text-field
									label="Nombre del certificado"
									solo
									hide-details
									class="input-text"
									v-model="certificate.name"
								></v-text-field>
								<!-- <span
									class="form-group__message"
									:style="`color:${$appColors.error}`"
									v-if="$v.model.name.$invalid"
								>
									El nombre es requerido
								</span> -->
							</v-flex>
							<v-flex xs12 lg5>
								<!-- <label
									class="name"
									:style="`color:${$appColors.info}`"
								>
									Año:
								</label>
								<v-text-field
									label="Año"
									solo
									hide-details
									class="input-text"
									v-model="certificate.year"
								></v-text-field> -->
								<label
									class="name"
									:style="`color:${$appColors.info}`"
								>
									Fecha de ingreso
								</label>
								<app-date-flat
									v-if="certificate.date"
									class="input-text"
									date-format="Y-m-d"
									v-model="certificate.date"
									:default-date="certificate.date"
									:enable-time="false"
									:blockFutureDates="true"
									:style="`border-radius:4px; color: ${$appColors.info} !important`"
									@input="changeDate({ model: 'date', value: $event })"
								></app-date-flat>
							</v-flex>
							<v-flex xs12 lg5 mt-4>
								<label
									class="name"
									:style="`color:${$appColors.info}`"
								>
									Duración en horas:
								</label>
								<v-text-field
									label="Duración en horas"
									solo
									hide-details
									class="input-text"
									v-model="certificate.durationHours"
								></v-text-field>
								<!-- <span
									class="form-group__message"
									:style="`color:${$appColors.error}`"
									v-if="$v.model.name.$invalid"
								>
									El nombre es requerido
								</span> -->
							</v-flex>
							<v-flex xs12 lg5 mt-4>
								<label
									class="name"
									:style="`color:${$appColors.info}`"
								>
									Centro de estudios:
								</label>
								<v-text-field
									label="Centro de estudios"
									solo
									hide-details
									class="input-text"
									v-model="certificate.studyCenter"
								></v-text-field>
								<!-- <span
									class="form-group__message"
									:style="`color:${$appColors.error}`"
									v-if="$v.model.name.$invalid"
								>
									El nombre es requerido
								</span> -->
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout row wrap mt-4 class="justify-space-between url-button">
					<v-flex xs12 lg4>
						<v-text-field
							label="Inserta URL"
							solo
							hide-details
							class="input-text"
							v-model="certificate.url"
							prepend-inner-icon='link'
							:disabled="verifyFile"
						></v-text-field>
					</v-flex>
					<v-flex xs12 lg7 text-xs-center>
						<v-btn 
							:disabled="$v.$invalid || (!verifyFile && !verifyUrl)"
							class="save"
							@click="save"
						>
							Guardar
						</v-btn>
					</v-flex>
				</v-layout>
				<v-layout row>
					<v-flex xs12>
						<app-table
							class="is-not-selectable mt-3 no-main-list"
							:columns="columns"
							:rows="certificates"
							:filter-columns="false"
							:main-list="true"
							:apply-width="true"
							:total-items="certificates.length"
							:last-page="totalPages"
							:current-page="currentPage"
							:items-quantity="certificates.length"
							:items-total-quantity="totalItems"
							@on-search-event="onSearchEvent"
							@on-page="changePage"
							title="CERTIFICADOS SUBIDOS"
						>
							<template slot="rows" slot-scope="props">
								<td style="width: 20%;" v-show="showRow(columns, 1)">
									<app-tooltip-button
										img="/static/img/icons/pdf.svg"
										text="Ver certificado"
										@click-icon="viewPdf(props.row.url)"
									/>
								</td>
								<td style="width: 20%;" v-show="showRow(columns, 2)">{{ props.row.name }}</td>
								<td style="width: 20%;" v-show="showRow(columns, 3)">{{ props.row.durationHours }}</td>
								<td style="width: 20%;" v-show="showRow(columns, 4)">{{ props.row.year }}</td>
								<td style="width: 20%;" v-show="showRow(columns, 5)">{{ props.row.studyCenter }}</td>
							</template>
						</app-table>
					</v-flex>
				</v-layout>
			</div>
		</layout-login>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { format } from 'date-fns';
import loadFile from '@/components/shared/load-image';
import dragAndDropFile from '@/components/shared/drag-and-drop-file';
import appDateFlat from '@/components/shared/app-date-flat';

async function created() {
	try {
		const { temporaryToken, id } = this.$route.params;
		this.temporaryToken = temporaryToken;
		this.id = id;
		const { data: dataApplicant } = await this.$httpPraktiko.get(`temporary-token/detail/${this.temporaryToken}`);
		this.recruitmentId = dataApplicant.recruitmentId;
		this.applicant.urlImage = dataApplicant.urlImageApplicant ||
			'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/user-null.svg';
		this.applicant.fullName = `${dataApplicant.name} ${dataApplicant.lastName}`;
		await this.loadCurrentAccademic();
		this.boxes = [
			{ id: 1, nameInfo: 'Tu puesto actual:', job: dataApplicant.jobName, color: 'var(--sectitle, #F09C2B' },
			{ id: 2, nameInfo: 'Nivel Académico mínimo:', job: dataApplicant.jobDescription, color: 'var(--greyrborders, #B8B8B8)' },
			{
				id: 3,
				nameInfo: 'Nivel académico actual:',
				job: this.currentAcademicLevel ? this.currentAcademicLevel : '',
				color: 'var(--maintitle, #55AC4B)',
			},
		];
		this.loadCertificates();
	} catch (error) {
		if (error.data.statusCode === 400) {
			if (error.data.message === 'TOKEN_HAS_EXPIRED') {
				this.showGenericError('El código de acceso ya ha caducado.');
				this.goTo('login');
			} else if (error.data.message === 'TOKEN_NOT_EXIST') {
				this.showGenericError('El código de acceso ya ha sido utilizado.');
				this.goTo('login');
			}
		} else {
			this.showGenericError();
		}
	}
}

async function loadCurrentAccademic() {
	try {
		const params = {
			token: this.temporaryToken,
		};
		({ data: this.currentAcademicLevel } = await this.$httpPraktiko(`applicants-recruitment/no-auth/detail/${this.recruitmentId}/${this.id}`, { params }));
	} catch (error) {
		this.showGenericError();
	}
}

async function loadCertificates() {
	try {
		this.params.token = this.temporaryToken;
		const params = { ...this.params };
		const { data: response, headers } =
			await this.$httpPraktiko(`certificates-applicant/${this.id}`, { params });
		this.certificates = response;
		this.totalItems = Number(headers['x-quantity']);
		this.totalPages = Number(headers['x-last-page']);
	} catch (error) {
		this.goTo('login');
		this.showGenericError();
	}
}
function clearData() {
	this.certificate = {
		name: null,
		date: format(new Date(), 'YYYY-MM-DD'),
		durationHours: null,
		studyCenter: null,
		url: null,
	};
	this.formData = new FormData();
	this.files = [];
}

async function save() {
	try {
		this.formData.append('name', this.certificate.name);
		this.formData.append('date', this.certificate.date);
		this.formData.append('durationHours', Number(this.certificate.durationHours));
		this.formData.append('studyCenter', this.certificate.studyCenter);
		this.formData.append('applicantId', this.$route.params.id);
		this.formData.append('token', this.$route.params.temporaryToken);
		if (this.certificate.url) {
			this.formData.delete('file');
			this.formData.append('url', this.certificate.url);
		} else {
			this.formData.delete('url');
		}
		const { status } = await this.$httpPraktiko.post('certificates-applicant', this.formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		if (status === 201) {
			this.showNotification('Registro creado exitosamente');
			this.loadCertificates();
		}
	} catch (error) {
		this.showGenericError();
	} finally {
		this.clearData();
	}
}

async function uploadFile(files) {
	try {
		this.files = files;
		if (!this.formData.has('file')) {
			this.formData.append('file', files[0]);
			this.formData.delete('url');
		}
		this.clean = false;
	} catch (error) {
		this.showGenericError('Error al subir el archivo');
	}
}

function viewPdf(pdfUrl) {
	if (pdfUrl) {
		window.open(pdfUrl, '_blank');
	} else {
		this.showGenericError('La URL del PDF no es válida.');
	}
}

function verifyFile() {
	return this.files.length > 0;
}

function verifyUrl() {
	return this.certificate.url !== null && this.certificate.url !== '';
}

function validations() {
	return {
		certificate: {
			name: { required },
			date: { required },
			durationHours: { required },
			studyCenter: { required },
		},
	};
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadCertificates();
}

function onSearchEvent(search) {
	this.params.search = search.trim() || null;
	this.changePage(1);
}

async function toggleEdit(state) {
	this.isEditing = state;
	const found = this.boxes.find(f => f.id === 3);
	const payload = {
		currentAcademicLevel: found.job || '',
		token: this.temporaryToken,
	};
	if (state === false) {
		try {
			await this.$httpPraktiko.patch(`applicants-recruitment/no-auth/${this.recruitmentId}/${this.id}`, payload);
			this.showNotification('Nivel académico actualizado con éxito');
		} catch (error) {
			this.showGenericError();
		}
	}
}

function changeDate({ model, value }) {
	if (value) {
		this.certificate[model] = format(new Date(value), 'YYYY-MM-DD');
	}
}

function data() {
	return {
		applicant: {
			fullName: null,
			urlImage: null,
		},
		boxes: [],
		certificates: [],
		certificate: {
			name: null,
			date: format(new Date(), 'YYYY-MM-DD'),
			durationHours: null,
			studyCenter: null,
			url: null,
		},
		svgUrl: '',
		columns: [
			{ id: 1, name: 'Archivo', value: 'file', checked: true, visible: true, size: 20 },
			{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true, size: 20 },
			{ id: 3, name: 'Duración en horas', value: 'durationHours', checked: true, visible: true, size: 10 },
			{ id: 4, name: 'Año', value: 'year', checked: true, visible: true, size: 10 },
			{ id: 5, name: 'Centro de Estudios', value: 'stydyCenter', checked: true, visible: true, size: 40 },
		],
		formData: new FormData(),
		files: [],
		clean: false,
		params: {
			limit: 10,
			page: 1,
		},
		currentPage: 1,
		totalPages: 0,
		totalItems: 0,
		temporaryToken: null,
		id: null,
		isEditing: false,
		recruitmentId: null,
		currentAcademicLevel: '',
	};
}

export default {
	name: 'create-profile',
	data,
	created,
	components: {
		loadFile,
		dragAndDropFile,
		appDateFlat,
	},
	computed: {
		verifyFile,
		verifyUrl,
	},
	methods: {
		uploadFile,
		loadCertificates,
		save,
		clearData,
		viewPdf,
		changePage,
		onSearchEvent,
		toggleEdit,
		loadCurrentAccademic,
		changeDate,
	},
	validations,
};
</script>

<style lang="scss" scoped>
	.general-titles {
		color: var(--maintitle, #55AC4B);
		font-family: "Neuzeit Grotesk";
		font-size: 24px;
		font-style: normal;
		font-weight: 700;
		line-height: normal;
	}

	.profile {
		margin: 0 45px 45px 45px;
	}

	.header {
		height: 92px;
		flex-shrink: 0;
		padding: 34px 0px 33px 0;
		h5 {
			color: var(--maintitle, #55AC4B);
			font-family: NeuzeitGroteskCondW01-Black;
			font-size: 22px;
			font-style: normal;
			font-weight: 900;
			line-height: normal;
		}
	}

	.wrapper-user-image {
		width: 90px;
		position: relative;
	}
	.wrapper-user {
		border-radius: 50%;
		height: 140px;
		margin-left: auto;
		overflow: hidden;
		width: 140px;
	}

	.wrapper-camera {
		bottom: 80px;
		position: absolute;
		right: -50px;
	}

	.info-applicant {
		padding-top: 10px;
		h4 {
			color: var(--greymain, #5C625C);
			font-family: "Neuzeit Grotesk";
			font-size: 38px;
			font-style: normal;
			font-weight: 500;
			line-height: normal;
		}
		p {
			color: var(--greymain, #5C625C);
			font-family: NeuzeitGroteskW01-Regular;
			font-size: 20px;
			font-style: normal;
			font-weight: 400;
			line-height: normal;
		}
	}

	.box {
		border-radius: 6px;
		width: 501px;
		height: 129px;
		flex-shrink: 0;
		p {
			color: var(--white, #FFF);
			text-align: center;
			font-family: NeuzeitGroteskW01-Regular;
			font-size: 20px;
			font-style: normal;
			font-weight: 400;
			line-height: normal;
		}
		h3 {
			color: var(--white, #FFF);
			font-family: NeuzeitGroteskCondW01-Black;
			font-size: 24px;
			font-style: normal;
			font-weight: 900;
			line-height: normal;
		}
	}
	.certificates {
		.title-qualifications {
			padding: 20px 0;
			h3 {
				color: var(--greymain, #5C625C);
				font-family: "Neuzeit Grotesk";
				font-size: 30px;
				font-style: normal;
				font-weight: 500;
				line-height: normal;
			}
			p {
				color: var(--greymain, #5C625C);
				font-family: NeuzeitGro;
				font-size: 20px;
				font-style: normal;
				font-weight: 400;
				line-height: normal;
			}
		}
	}

	.url-button {
		.save {
			width: 192px;
			height: 38px;
			flex-shrink: 0;
			border-radius: 19px;
			background: var(--maintitle, #55AC4B) !important;
			align-content: center;
			color: var(--white, #FFF) !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/professional-profile/create-profile.vue